import { useQuery } from "react-query";
import { UserRes } from "../types";
import { generateSignedRequestConfig, getBaseUrl } from "../utils";

const useGetClientToken = ({ queryConfig, user }: { queryConfig: any, user: UserRes }) => {
  const { apiKey, apiSecret, countryCode, id } = user;

  const config = generateSignedRequestConfig({
    apiKey,
    apiSecret,
    countryCode,
    id,
    method: 'GET',
    url: `${getBaseUrl()}/api/billing/braintree/token/${id}`,
  });

  const queryFn = () => fetch(config.url, { ...config }).then(res => res.text())

  return useQuery(
    [
      'clientToken',
      {
        config
      },
    ],
    queryFn,
    queryConfig
  );
}

export default useGetClientToken